import { render, staticRenderFns } from "./updateMenu.vue?vue&type=template&id=20ee7ce3&"
import script from "./updateMenu.vue?vue&type=script&lang=js&"
export * from "./updateMenu.vue?vue&type=script&lang=js&"
import style0 from "./updateMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports